import { render, staticRenderFns } from "./SupplierViewGlobal.vue?vue&type=template&id=04ca1bcc"
import script from "./SupplierViewGlobal.vue?vue&type=script&lang=js"
export * from "./SupplierViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports